const Block = ({height}) => {    

    return (
        <div style={{height}} ></div>
    );
    
}
 
export default Block;
